module.exports = __webpack_public_path__ + "img/blue_147.f1b3cca0.png";